import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "./Motion";
import { LP_UI, LP_PRODUCTS } from "../lib/liveProducts";

const LiveProductsSection = () => {
  const { lang } = useLang();
  const ui = LP_UI[lang] || LP_UI.de;
  const items = LP_PRODUCTS.filter((p) => p.status === "live");

  return (
    <section
      id="live-products"
      data-testid="home-live-products"
      className="scroll-mt-24 border-t border-white/10 bg-obsidian-soft py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs uppercase tracking-[0.35em] text-champagne">{ui.overline}</span>
              <h2 className="mt-4 max-w-2xl font-serif text-3xl font-light leading-tight text-white md:text-4xl">
                {ui.homeTitle}
              </h2>
              <p className="mt-3 max-w-xl text-base font-light leading-relaxed text-white/55">{ui.homeSub}</p>
            </div>
            <Link
              to="/live-products"
              data-testid="home-live-products-cta"
              className="inline-flex w-fit items-center gap-2 border border-champagne/40 px-6 py-3 text-[11px] uppercase tracking-[0.2em] text-champagne transition-colors hover:bg-champagne/10"
            >
              {ui.homeCta} <ArrowRight size={14} />
            </Link>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {items.map((p, i) => {
            const Icon = p.Icon;
            return (
              <Reveal key={p.slug} delay={i * 0.1}>
                <a
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`home-live-product-${p.slug}`}
                  className="group flex h-full flex-col border border-white/12 bg-white/[0.03] p-8 transition-colors hover:border-champagne/40"
                >
                  <div className="flex items-center justify-between">
                    <span className="flex h-11 w-11 items-center justify-center border border-champagne/30 text-champagne">
                      <Icon size={20} strokeWidth={1.5} />
                    </span>
                    <ArrowUpRight size={18} className="text-white/30 transition-colors group-hover:text-champagne" />
                  </div>
                  <span className="mt-6 text-[10px] uppercase tracking-[0.3em] text-white/40">
                    {p.category[lang] || p.category.de}
                  </span>
                  <h3 className="mt-2 font-serif text-2xl font-light text-white">{p.name}</h3>
                  <p className="mt-3 text-[14px] font-light leading-relaxed text-white/60">
                    {p.tagline[lang] || p.tagline.de}
                  </p>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LiveProductsSection;
